import React from 'react';
import { FormLabel as ChakraFormLabel, FormLabelProps as ChakraFormLabelProps } from '@chakra-ui/react';

export function FormLabel(props: ChakraFormLabelProps) {
  return <ChakraFormLabel {...props} />;
}
